// Elements allowed to contain a highlight span.
export const Settings = {
    elementWhitelist: ['a', 'i', 'b', 'u', 'strong', 'th', 'td', 'p', 'div', 'span', 'em', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'sub', 'sup'],
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/abstractselection/config.tsx